import { render, staticRenderFns } from "./cancelOrderModal.vue?vue&type=template&id=5495e223&"
import script from "./cancelOrderModal.vue?vue&type=script&lang=js&"
export * from "./cancelOrderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports